import { Injectable } from '@angular/core';
import { Action, Selector, State, StateContext } from '@ngxs/store';
import { ShipmentWaybillTrackingService } from './shipment-waybill-tracking.service';
import { catchError, map } from 'rxjs/operators';
import { Observable, of } from 'rxjs';
import { NotificationService } from '../../../../../common/services/notification/notification.service';
import { Error, CustomHttpErrorResponse } from '../../../../../common/constants/error';
import {
  ShipmentWaybillTrackingLoad,
  ShipmentWaybillTrackingSetInitialState,
} from './shipment-waybill-tracking.actions';
import { ShipmentWaybillMilestoneModel } from '../../models';
import { MatSnackBarRef, SimpleSnackBar } from '@angular/material/snack-bar';

export interface ShipmentWaybillTrackingStateModel {
  milestones: ShipmentWaybillMilestoneModel[];
  loaded: boolean;
}

const initialState: ShipmentWaybillTrackingStateModel = {
  milestones: [],
  loaded: false,
};

@State<ShipmentWaybillTrackingStateModel>({
  name: 'shipmentWaybillTracking',
  defaults: initialState,
})
@Injectable()
export class ShipmentWaybillTrackingState {
  constructor(
    private shipmentWaybillOverviewService: ShipmentWaybillTrackingService,
    private notificationService: NotificationService,
  ) {}
  @Selector()
  static getState(state: ShipmentWaybillTrackingStateModel): ShipmentWaybillTrackingStateModel {
    return state;
  }

  @Selector()
  static getLoaded(state: ShipmentWaybillTrackingStateModel): boolean {
    return state.loaded;
  }

  @Selector()
  static getMilestones(state: ShipmentWaybillTrackingStateModel): ShipmentWaybillMilestoneModel[] {
    return state.milestones;
  }

  @Action(ShipmentWaybillTrackingLoad)
  getWaybillTracking(
    ctx: StateContext<ShipmentWaybillTrackingStateModel>,
    { payload }: ShipmentWaybillTrackingLoad,
  ): Observable<MatSnackBarRef<SimpleSnackBar> | void> {
    return this.shipmentWaybillOverviewService.getMilestonesData(payload).pipe(
      map(({ milestones }: { milestones: ShipmentWaybillMilestoneModel[] }) => {
        ctx.patchState({ milestones, loaded: true });
      }),
      catchError(({ error }: CustomHttpErrorResponse<Error>) => of(this.notificationService.error(error.message))),
    );
  }

  @Action(ShipmentWaybillTrackingSetInitialState)
  setInitialState(ctx: StateContext<ShipmentWaybillTrackingStateModel>): void {
    ctx.setState(initialState);
  }
}
